import type { TSetTranslationKeys } from '@crehana/ts-types';

import type es from './localeEs';

export type TKeys = TSetTranslationKeys<typeof es>;

type TTranslations = { pt: Record<TKeys, string> };

const localeViewPt: TTranslations = {
  pt: {
    MENU_ROUTE_HOME: 'Início',
    MENU_ROUTE_HANA_AI: 'Crehana AI',
    MENU_ROUTE_HANA_AI_ASSISTANT: 'Assistente',
  },
};

export default localeViewPt;
